// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1WBO2","title":"ClientReferral_title__2K7op","itemText":"ClientReferral_itemText__Bs7ry"};